import request from '@/utils/request'

export function options() {
  return request({
    url: '/api/bdPortArea/options',
    method: 'get'
  })
}

export function page(params) {
  return request({
    url: '/api/bdPortArea/page',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/api/bdPortArea',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/api/bdPortArea',
    method: 'put',
    data
  })
}

export function batchDel(ids) {
  return request({
    url: '/api/bdPortArea/batch',
    method: 'delete',
    data: ids
  })
}

export function getById(id) {
  return request({
    url: '/api/bdPortArea',
    method: 'get',
    params: {
      id
    }
  })
}
